/* eslint-disable @typescript-eslint/no-explicit-any */
import { isObservable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppError } from '../models/error.model';
import { dispatchAppError } from '../utils/error-dispatcher';
import { handleError } from '../utils/error.utils';

export enum ErrorType {
  PAGE = 'PAGE',
  ACTION = 'ACTION',
  CUSTOM = 'CUSTOM',
}

export function catchAppError(cb: (error: AppError) => any, type: ErrorType = ErrorType.ACTION) {
  return catchError((error) => {
    const appError: AppError = error?.type === 'REQUEST' || error?.type === 'CODE' ? error : handleError(error);

    if (appError.type === 'CODE') {
      console.error(error);
    }

    if (type !== ErrorType.CUSTOM) {
      dispatchAppError(appError, type);
    }

    const result = cb(appError);
    return isObservable(result) ? result : of(result);
  });
}
